import React, { useState } from "react";
import StoreNewBank from "./StoreNewBank";  // Import StoreNewBank
import NewBkdata from "./NewBkdata";  // Import NewBkdata

const AddBank = ({ resetCurrency, selectedCurrency }) => {
  // State to manage whether to show Add or View mode
  const [viewMode, setViewMode] = useState(null);

  // Handle selecting a currency and switching between Add/View mode
  const handleSelectCurrency = (currency, mode) => {
    resetCurrency(currency);  // Update selected currency
    setViewMode(mode);  // Update view mode based on the button clicked (Add/View)
  };

  // Currency icons
  const currencyIcons = {
    USD: '/images/currency/usd_90681e5a82.svg',
    EUR: '/images/currency/eur_2fb3ea3cae.svg',
  };

  return (
    <div className="cus-dash-container container">
      <h5 className="card-title text-justify">Bank Details</h5>

      {/* Render based on selectedCurrency and viewMode */}
      {selectedCurrency && viewMode ? (
        viewMode === "add" ? (
          <StoreNewBank currency={selectedCurrency} />  // Show Add Component
        ) : (
          <NewBkdata currency={selectedCurrency} />  // Show View Component
        )
      ) : (
        <div className="row mt-2">
          {/* USD Section - Left Side (6 columns) */}
          <div className="col-12 d-flex align-items-center mb-3">
            <h3 className="mr-4">
              <img
                src={currencyIcons.USD}
                alt="USD Icon"
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
              />
              USD
            </h3>
            <button
              className="btn btn-primary m-2"
              onClick={() => handleSelectCurrency("USD", "add")}  // Clicked Add for USD
            >
              Add
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => handleSelectCurrency("USD", "view")}  // Clicked View for USD
            >
              View
            </button>
          </div>

          {/* Euro Section - Right Side (6 columns) */}
          <div className="col-12 d-flex align-items-center mb-3">
            <h3 className="mr-4">
              <img
                src={currencyIcons.EUR}
                alt="EUR Icon"
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
              />
              Euro
            </h3>
            <button
              className="btn btn-primary m-2"
              onClick={() => handleSelectCurrency("EUR", "add")}  // Clicked Add for EUR
            >
              Add
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => handleSelectCurrency("EUR", "view")}  // Clicked View for EUR
            >
              View
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddBank;
